
import { supabase } from './supabase';

// Initialize Gemini
// let genAI = null;
// let model = null;

// if (API_KEY) {
//     try {
//         genAI = new GoogleGenerativeAI(API_KEY);
//         model = genAI.getGenerativeModel({ model: "gemini-2.5-flash" });
//     } catch (error) {
//         console.error("Fout bij initialiseren Gemini AI:", error);
//     }
// } else {
//     console.warn("⚠️ Geen VITE_GEMINI_API_KEY gevonden in .env.local. AI functies werken in beperkte modus.");
// }

/**
 * Stuurt een prompt naar Gemini (Hybride: eerst Lokaal Nano, dan Cloud Proxy).
 * @param {string} prompt - De vraag of opdracht voor de AI
 * @param {Array} history - (Optioneel) Chatgeschiedenis voor context
 * @returns {Promise<string>} - Het antwoord van de AI
 */
export const askGemini = async (prompt, history = []) => {
    // 1. Probeer Gemini Nano (Lokaal & Gratis)
    if (window.ai && window.ai.languageModel) {
        try {
            const capabilities = await window.ai.languageModel.capabilities();
            if (capabilities.available !== "no") {
                // Maak een sessie aan
                const session = await window.ai.languageModel.create();

                // Bouw context op vanuit history (Nano heeft geen native history parameter in deze versie)
                let fullPrompt = prompt;
                if (history.length > 0) {
                    // Simpele platgeslagen context voor Nano
                    const historyText = history.map(h => `${h.role === 'user' ? 'User' : 'Model'}: ${h.parts[0].text}`).join('\n');
                    fullPrompt = `Context:\n${historyText}\n\nUser Question: ${prompt}`;
                }

                console.log("⚡ Using Gemini Nano (Local AI)");
                const result = await session.prompt(fullPrompt);
                return result;
            }
        } catch (localError) {
            console.warn("⚠️ Nano beschikbaar maar faalde, fallback naar Cloud:", localError);
            // Ga door naar Cloud Fallback
        }
    }

    // 2. Cloud Proxy (Supabase Edge Function)
    // Dit is veilig omdat de Frontend GEEN API Key meer nodig heeft.
    try {
        const { data, error } = await supabase.functions.invoke('ask-ai', {
            body: { prompt, history }
        });

        if (error) throw error;
        return data.text;

    } catch (error) {
        console.error("Cloud AI Proxy Error:", error);
        return "Sorry, de AI is even niet bereikbaar (Nano & Cloud faalden).";
    }
};

/**
 * Systeem context voor de Help Assistent.
 * Dit helpt de AI om te weten wie hij is (ProPoule expert).
 */
export const PROPOULE_SYSTEM_PROMPT = `
Je bent de virtuele assistent van de app 'ProPoule'. ProPoule is een toernooi-beheer applicatie voor voetbal, tennis, darts en andere sporten.
Je doel is om gebruikers (toernooi organisatoren) te helpen met vragen over de app.

Belangrijke kennis over ProPoule:
1. Maken: Je maakt een toernooi via de grote oranje knop 'Nieuw Toernooi' op het dashboard.
2. TV Modus: Er is een 'Presentatie Modus' voor TV schermen in de kantine. Dit vind je in het menu onder 'Presentatie'. Druk op F11 voor volledig scherm.
3. Scheidsrechters: Die loggen in via een publieke link met een pincode (standaard 0000).
4. Standen: Worden automatisch berekend (Punten -> Doelsaldo -> Doelpunten voor).
5. King of The Court: Een speciaal speltype waar teams doorschuiven naar een hoger/lager veld na elke ronde.
6. Inschrijfgeld & Mollie Betalingen: Organisatoren kunnen inschrijfgeld instellen in Toernooi-instellingen. Teams betalen direct via iDEAL, Bancontact of Creditcard bij online inschrijving. Gebruik een test API-sleutel (begint met 'test_') om de betalings-flow veilig te testen.
7. Premium Sponsors: Organisatoren kunnen sponsoren beheren op de Sponsoren-pagina. Sponsoren worden realtime getoond in de TV-modus presentatie slideshow en roteren interactief als footer op de mobiele publieke live-pagina.

Houd je antwoorden kort, vriendelijk en praktisch. Gebruik emojis waar passend 🏆.
Als je het antwoord niet zeker weet, zeg dat dan eerlijk en raad aan om de handleiding te bekijken.
`;

/**
 * Genereert een kort, leuk commentaar op een wedstrijd uitslag.
 */
export const getMatchCompliment = async (homeName, awayName, scoreHome, scoreAway) => {
    // Kleine optimalisatie: als scores gelijk zijn of 0-0, vraag iets specifieks
    const prompt = `
    Schrijf een super kort, enthousiast reactie (max 1 zin + emoji) op deze uitslag:
    ${homeName} vs ${awayName}: ${scoreHome} - ${scoreAway}.
    Wees creatief, sportief en gebruik humor.
    Voorbeelden:
    - "Wat een monsterzege voor ${scoreHome > scoreAway ? homeName : awayName}! 🔥"
    - "Spanning tot de laatste minuut! 😅"
    - "De punten worden gedeeld 🤝"
    `;

    try {
        // Gebruik de bestaande askGemini functie
        const response = await askGemini(prompt);
        return response.replace(/"/g, ''); // Strip quotes
    } catch (e) {
        return "Lekker gespeeld! ⚽";
    }
};
